import React, { useMemo, useState } from 'react';

function StatusBadge({ value }) {
    const isActive = String(value).toLowerCase() === 'active';
    return <span className={`status-pill${isActive ? ' active' : ''}`}>{value}</span>;
}

export default function InventoryTablePage({
    title,
    breadcrumb,
    rows,
    columns,
    primaryActionLabel,
    toolbarButtons,
    filterOptions,
    searchPlaceholder = 'Search',
    extraHeader,
}) {
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState('all');

    const filteredRows = useMemo(() => {
        const q = search.trim().toLowerCase();
        return rows.filter((row) => {
            const matchesSearch = !q || Object.values(row).some((value) => String(value ?? '').toLowerCase().includes(q));
            const matchesFilter = filter === 'all' || String(row.status || '').toLowerCase() === filter;
            return matchesSearch && matchesFilter;
        });
    }, [rows, search, filter]);

    return (
        <div className="products-page">
            <div className="page-header products-header">
                <div>
                    <h2>{title}</h2>
                    <p>Dashboard <span className="crumb-sep">›</span> {breadcrumb || title}</p>
                </div>
                <div className="products-toolbar-actions">
                    {toolbarButtons || (
                        <>
                            <button className="mini-icon-btn" type="button">🧾</button>
                            <button className="mini-icon-btn" type="button">📗</button>
                            <button className="mini-icon-btn" type="button">↻</button>
                            <button className="mini-icon-btn" type="button">⌃</button>
                            <button className="btn" type="button">{primaryActionLabel}</button>
                        </>
                    )}
                </div>
            </div>

            <section className="products-shell inventory-list-shell">
                {extraHeader}
                <div className="products-filters">
                    <div className="products-search">
                        <span>⌕</span>
                        <input placeholder={searchPlaceholder} value={search} onChange={(e) => setSearch(e.target.value)} />
                    </div>

                    <div className="products-filter-right">
                        {filterOptions || (
                            <select value={filter} onChange={(e) => setFilter(e.target.value)}>
                                <option value="all">Status</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                        )}
                    </div>
                </div>

                <div className="products-table-wrap">
                    <table className="products-table admin-table">
                        <thead>
                            <tr>
                                <th><input type="checkbox" readOnly /></th>
                                {columns.map((column) => (
                                    <th key={column.key}>{column.label}</th>
                                ))}
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredRows.length === 0 ? (
                                <tr>
                                    <td colSpan={columns.length + 2} className="dash-empty-row">No data available</td>
                                </tr>
                            ) : filteredRows.map((row) => (
                                <tr key={row.id}>
                                    <td><input type="checkbox" readOnly /></td>
                                    {columns.map((column) => (
                                        <td key={column.key}>
                                            {column.render
                                                ? column.render(row)
                                                : column.key === 'status'
                                                    ? <StatusBadge value={row[column.key]} />
                                                    : row[column.key]}
                                        </td>
                                    ))}
                                    <td>
                                        <div className="product-actions">
                                            <button className="mini-icon-btn" type="button">✎</button>
                                            <button className="mini-icon-btn" type="button">🗑</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="products-footer-bar">
                    <div className="products-footer-left">
                        <span>{filteredRows.length} of {rows.length} records</span>
                    </div>
                </div>
            </section>
        </div>
    );
}
